import { useEffect, useState } from "react";
import { useOnchainUpdate } from "./useOnchain";

export function useGenericCallback<DataGetterType>(dataGetter: DataGetterType, f: (dataGetter: DataGetterType) => void, a?: Array<any>) {
  const onchainUpdate = useOnchainUpdate();
  return useEffect(() => {
    if (dataGetter) f(dataGetter);
  }, [dataGetter, onchainUpdate].concat(a));
}

export default function useGenericCall<DataGetterType,T>(dataGetter: DataGetterType, f: (dataGetter: DataGetterType) => Promise<T>, a?: Array<any>) : T {
  const [data, setData] = useState<T>(null);
  useGenericCallback<DataGetterType>(dataGetter, async (dataGetter) => {
    const d = await f(dataGetter)
    setData( d )
  }, a);
  return data;
}